<template>
  <div id="hygrldsh">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'hygrldsh'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/member/leaderApprove/person/Hygrldsh.vue